import { isDeletedAccountUser } from "./deletedAccount";
import { toApiAbsoluteUrl } from "./ws";

const INLINE_URL_RE = /^(?:data:|blob:)/i;
const ABSOLUTE_URL_RE = /^https?:\/\//i;
const IMAGE_EXTENSION_RE = /\.(?:avif|gif|jpe?g|png|svg|webp)(?:[?#].*)?$/i;
const GUEST_AVATAR_COUNT = 30;

export const guestAvatarSrc = (seed) => {
  const value = String(seed ?? "");
  let hash = 2166136261;
  for (let index = 0; index < value.length; index += 1) {
    hash = Math.imul(hash ^ value.charCodeAt(index), 16777619);
  }
  const number = ((hash >>> 0) % GUEST_AVATAR_COUNT) + 1;
  return `/assets/guest-avatars/${String(number).padStart(2, "0")}.webp`;
};

export const resolveAvatarMediaSrc = (rawUrl) => {
  const value = String(rawUrl || "").trim();
  if (!value) return null;
  if (INLINE_URL_RE.test(value) || ABSOLUTE_URL_RE.test(value)) return value;
  if (value.startsWith("/assets/")) return value;
  if (value.startsWith("//")) return toApiAbsoluteUrl(value);
  if (value.startsWith("/") || value.includes("/")) {
    return toApiAbsoluteUrl(value);
  }
  if (IMAGE_EXTENSION_RE.test(value)) {
    return `/assets/avatars/${value}`;
  }
  return `/assets/avatars/${value}.webp`;
};

export const resolveUserAvatarSrc = (user, fallback = null) => {
  if (isDeletedAccountUser(user)) return null;
  const nestedUser = user?.user && typeof user.user === "object" ? user.user : null;
  const guestSeed = user?.guest_avatar_seed ?? nestedUser?.guest_avatar_seed;
  if (guestSeed != null) return guestAvatarSrc(guestSeed);
  const customAvatar =
    user?.avatar_custom_url ||
    user?.avatar_url ||
    user?.imageUrl ||
    nestedUser?.avatar_custom_url ||
    nestedUser?.avatar_url ||
    nestedUser?.imageUrl;
  if (customAvatar) return resolveAvatarMediaSrc(customAvatar) || fallback;

  const presetAvatar = user?.avatar || nestedUser?.avatar;
  if (presetAvatar) return resolveAvatarMediaSrc(presetAvatar) || fallback;
  return fallback;
};
